import styles from "./AnalyticsLoader.module.scss";

export const AnalyticsLoader = () => (
  <div className={styles.loaderWrapper}>
    <div className={styles.loadingBox}>
      <div className={styles.loader} />
    </div>
  </div>
);